import { classNames } from 'primereact/utils';
import React from 'react';
import { Control, Controller, RegisterOptions } from 'react-hook-form';
import { BaseSketchPicker } from '../input/BaseSketchPicker';

type RHFSketchPickerProps = {
    control: Control<any>;
    name: string;
    rules?: RegisterOptions;
    inputProps?: Record<string, unknown>;
};

export const RHFSketchPicker = ({ control, name, rules, inputProps }: RHFSketchPickerProps) => {
    return (
        <Controller
            name={name}
            control={control}
            rules={rules}
            render={({ field, fieldState }) => (
                <BaseSketchPicker
                    id={field.name}
                    color={field.value}
                    onChange={(color: { hex: string }) => field.onChange(color.hex)}
                    className={classNames({ 'p-invalid': fieldState.invalid })}
                    width='auto'
                    {...inputProps}
                />
            )}
        />
    );
};
